export const SSO_PROVIDER_ID_PATTERN = "[A-Za-z0-9_-]{1,64}";

export const LOGIN_TINES_PROVIDER_ID = "login-tines-com";

export const BUILT_IN_IDP_PROVIDER_ID = "local-idp";

export const DEFAULT_PROVIDER_IDS = new Set([
  LOGIN_TINES_PROVIDER_ID,
  BUILT_IN_IDP_PROVIDER_ID,
]);
